import React, { useEffect, useState } from 'react';

import { useFetchProject } from '../../shared/hooks/useFetchProject';
import { useSelector } from 'react-redux';
import { selectImageData, selectScriptData } from '../../store/selectors/projectSelectors';
import s from './ReadyPostPage.module.css';
import InstagramPost from '../../shared/ui/instagram-post/InstagramPost';

import LogoComponent from '../../shared/ui/logo/LogoComponent';
import Button from '../../shared/ui/button/Button';
import { useNavigate, useParams } from 'react-router-dom';
import IconEdit from '../../shared/ui/icons/IconEdit';
import IconCalendar from '../../shared/ui/icons/IconCalendar';
import IconRocket from '../../shared/ui/icons/IconRocket';
import IconStars from '../../shared/ui/icons/IconStars';
import { PostModal } from '../../shared/ui/post-modal/PostModal';

import { useAppDispatch } from '../../store/store';
import Loader from '../../shared/ui/loader/Loader';
import {
    selectIsFreeSubscription,
    selectPostsUsed,
    selectImageGenerated,
} from '../../store/selectors/subscriptionSelector';
import IconLock from '../../shared/ui/icons/IconLock';
import { setPricingModal } from '../../store/slices/pageSlice';
import { selectUser } from '../../store/selectors/authSelectors';

const ReadyPostPage = () => {
    useFetchProject();
    const dispatch = useAppDispatch();
    const [showPostModal, setShowPostModal] = useState(false);
    const scriptData = useSelector(selectScriptData);
    const imageData = useSelector(selectImageData);
    const { projectId } = useParams();
    const navigate = useNavigate();
    const isFreeSubscription = useSelector(selectIsFreeSubscription);
    const postsUsed = useSelector(selectPostsUsed);
    const user = useSelector(selectUser);
    const isRestrictPostFreeUser = postsUsed > 0 && isFreeSubscription;
    const imageGenerated = useSelector(selectImageGenerated);

    const isRestrictImageGenerate = imageGenerated > 4 && isFreeSubscription;

    const handleShareNow = () => {
        if (isRestrictPostFreeUser) {
            dispatch(setPricingModal(true));
        } else {
            setShowPostModal(true);
        }
    };

    const handleGenerateMultiplePosts = () => {
        if (isRestrictImageGenerate) {
            dispatch(setPricingModal(true));
        } else {
            navigate(`/multiple-posts/${projectId}`);
        }
    };
    if (scriptData === null || imageData === null) {
        return <Loader />;
    }
    return (
        <div className={s.container}>
            <LogoComponent />
            <div className={s.post_container_wrapper}>
                <div className={s.post_container}>
                    <h2 className={s.post_header}>You’re all set!</h2>
                    <p className={s.post_text}>
                        We’ve tailored this content for you based on your profile information. Let’s
                        make a post to start growing your brand
                    </p>

                    <p className={s.post_text}>
                        Nothing gets posted without you. You’re in full control.
                    </p>

                    <div className={s.button_container}>
                        <Button
                            text="Edit Post"
                            onClick={() => {
                                navigate(`/custom-post/${projectId}`);
                            }}
                            style={{
                                backgroundColor: '#fff',
                                border: '1px solid #E5E7EB',
                                height: '45px',
                            }}
                            iconPosition="left"
                            icon={<IconEdit />}
                        />

                        <Button
                            text="Schedule"
                            onClick={() => {
                                navigate(`/schedule`);
                            }}
                            style={{
                                backgroundColor: '#fff',
                                border: '1px solid #E5E7EB',
                                height: '45px',
                            }}
                            iconPosition="left"
                            icon={<IconCalendar />}
                        />

                        <Button
                            text="Generate 3 more like this"
                            onClick={handleGenerateMultiplePosts}
                            style={{
                                background: 'linear-gradient(90deg, #8801FF 0%, #D400FF 100%)',
                                color: '#fff',
                                height: '45px',
                            }}
                            iconPosition="left"
                            icon={
                                isRestrictImageGenerate ? (
                                    <IconLock width={16} height={16} color="white" />
                                ) : (
                                    <IconStars color="white" />
                                )
                            }
                        />

                        <Button
                            text="Post Now"
                            onClick={handleShareNow}
                            style={{ backgroundColor: '#FFDD35', height: '45px' }}
                            iconPosition="left"
                            icon={
                                isRestrictPostFreeUser ? <IconLock color="black" /> : <IconRocket />
                            }
                        />
                    </div>
                </div>
                <InstagramPost
                    avatar={user?.profile_picture || null}
                    name={user?.name || user?.username || user?.email || ''}
                    text={scriptData}
                    image={imageData}
                    isPosted={true}
                />
            </div>
            <PostModal isOpen={showPostModal} onClose={() => setShowPostModal(false)} />
        </div>
    );
};

export default ReadyPostPage;
